import Loader from '../Loader/Loader.vue.js';

//
var script = {
  name: 'LoaderBlock',
  components: {
    Loader: Loader
  },
  props: {
    text: {
      type: String,
      default: 'Загрузка...'
    },
    size: {
      type: String,
      default: 'normal'
    }
  }
};

export default script;
